import { Component } from '@theme/component';

/** Keeps a contact inquiry in the current tab across navigation and validation errors. */
class EvermarkdContactDraft extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }

  #bind() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const form = this.querySelector('form');
    if (!form) return;
    const fields = Array.from(form.elements).filter((field) =>
      ['contact[name]', 'contact[email]', 'contact[phone]', 'contact[body]',
        'contact[Project type]', 'contact[Requested quantity]', 'contact[Requested date]',
        'contact[Artwork link]'].includes(field.name)
    );
    const key = `evermarkd:contact-draft:${location.pathname}:${form.id}`;
    const result = this.querySelector('[data-contact-result]')?.dataset.contactResult;
    const notice = this.querySelector('[data-contact-draft-notice]');
    try {
      if (result === 'success') {
        sessionStorage.removeItem(key);
      } else {
        const draft = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (draft && typeof draft === 'object' && Date.now() - draft.savedAt < 86400000) {
          for (const field of fields) {
            const saved = draft.values?.[field.name];
            if (typeof saved !== 'string' || (result === 'error' && field.value && !(field instanceof HTMLSelectElement && !field.querySelector('[selected]')))) continue;
            if (field instanceof HTMLSelectElement && !Array.from(field.options).some((option) => option.value === saved)) continue;
            field.value = saved;
          }
          if (notice) notice.hidden = false;
        } else if (draft) {
          sessionStorage.removeItem(key);
        }
      }
    } catch {
      // Native form submission remains available when tab storage is unavailable.
    }
    this.dispatchEvent(new CustomEvent('evermarkd:contact-restored', { bubbles: true }));
    const save = () => {
      try {
        const values = Object.fromEntries(fields.map((field) => [field.name, field.value]));
        sessionStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), values }));
        if (notice) notice.hidden = false;
      } catch {
        if (notice) notice.hidden = true;
      }
    };
    const options = { signal: this.#controller.signal };
    form.addEventListener('input', save, options);
    form.addEventListener('change', save, options);
    form.addEventListener('submit', save, options);
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }
}

if (!customElements.get('evermarkd-contact-draft')) {
  customElements.define('evermarkd-contact-draft', EvermarkdContactDraft);
}
